export const validatePatientIntegrationsAthena = (field, value) => {
  let errMsg = '';
  switch (field) {
    case 'practiceId':
      if (!value) {
        errMsg = 'Practice ID should not be empty';
      }
      break;
    case 'athenaPatientId':
      if (!value) {
        errMsg = 'Athena patient ID should not be empty';
      }
      break;
    case 'department':
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
